import { Component, DestroyRef, ElementRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  FormGroup,
  Validators,
  FormBuilder,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
// Third Party
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import {
  Answers,
  ComponentNames,
  FirearmTypes,
  ModalID,
  ModalType,
  Questions,
} from 'src/app/shared/models/constants';
import { AddEditFirearmResponse } from 'src/app/shared/models/general';
import { Firearm } from 'src/app/shared/models/general';
// Services
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
    selector: 'app-firearm-management-edit',
    templateUrl: './firearm-management-edit.component.html',
    styleUrls: ['./firearm-management-edit.component.scss'],
    standalone: true,
    imports: [ReactiveFormsModule, NgSelectModule]
})
export class FirearmManagementEditComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  subscriptions = new Subscription();
  add_edit_firearm_form: FormGroup;
  modal_type: string;
  selected_row: Firearm = new Firearm();
  row_index: number;
  calling_component: string;

  firearm_types: string[] = [];

  duplicate_enabled_entry = true;
  duplicate_entry = true;

  // Modals
  modalRef: BsModalRef;
  modalConfig = { animated: true };

  constructor(
    protected element: ElementRef,
    private fb: FormBuilder,
    private sharedService: SharedService
  ) {
    // Initializing Form
    this.add_edit_firearm_form = this.fb.group({
      firearm_upc: new FormControl({ value: null, disabled: false }, [
        Validators.required,
      ]),
      firearm_type: new FormControl({ value: null, disabled: false }, [
        Validators.required,
      ]),
      manufacture: new FormControl({ value: null, disabled: false }, [
        Validators.required,
      ]),
      importer: new FormControl({ value: null, disabled: false }),
      model: new FormControl({ value: null, disabled: false }, [
        Validators.required,
      ]),
      additional_markings: new FormControl({ value: null, disabled: false }),
      caliber_gauge: new FormControl({ value: null, disabled: false }, [
        Validators.required,
      ]),
    });
    // yes_no_submit$
    this.subscriptions.add(
      this.sharedService.yes_no_submit$
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((response) => {
          if (
            response.answer === Answers.yes &&
            response.question === Questions.close_add_firearm_modal
          ) {
            this.closeNodal();
            this.sharedService.clear_bulk_acquisition_rows$.next(
              response.optional_details.row_index
            );
          }
        })
    );
  }
  ngOnInit(): void {
    this.firearm_types = FirearmTypes;
    this.firearm_types.push('test');
    this.firearm_types = [...this.firearm_types];
    if (this.modal_type === ModalType.edit) {
      this.add_edit_firearm_form.patchValue({
        firearm_upc: this.selected_row.firearm_upc,
        firearm_type: this.selected_row.firearm_type,
        manufacture: this.selected_row.manufacture,
        importer: this.selected_row.importer,
        model: this.selected_row.model,
        additional_markings: this.selected_row.additional_markings,
        caliber_gauge: this.selected_row.caliber_gauge,
      });
    } else if (this.modal_type === ModalType.add && this.selected_row) {
      this.add_edit_firearm_form.patchValue({
        firearm_upc: this.selected_row.firearm_upc,
      });
    }
  }
  closeModalClick(): void {
    if (this.calling_component === ComponentNames.bulk_acquisition) {
      const optional_details = { row_index: this.row_index };
      this.sharedService.openYesNoModal(
        Questions.close_add_firearm_modal,
        optional_details
      );
    } else {
      this.closeNodal();
    }
  }
  closeNodal(): void {
    this.add_edit_firearm_form.reset();
    this.selected_row = new Firearm();
    this.sharedService.closeModal(ModalID.firearm_management_edit);
  }
  addEditFirearmClick() {
    let return_data: AddEditFirearmResponse = new AddEditFirearmResponse();
    if (this.modal_type === ModalType.edit) {
      return_data.modal_type = ModalType.edit;
    } else {
      return_data.modal_type = ModalType.add;
    }
    this.allEntriesToUpperCase();
    return_data.form_values = this.add_edit_firearm_form.value;
    if (this.modal_type === ModalType.edit) {
      return_data.form_values.id = this.selected_row.id;
    }
    this.sharedService.firearm_to_add$.next(return_data);
    this.closeModalClick();
  }
  allEntriesToUpperCase() {
    const controls = this.add_edit_firearm_form.controls;
    for (const name in controls) {
      if (controls.hasOwnProperty(name)) {
        const control = controls[name];
        if (control.value) {
          control.setValue(control.value.toUpperCase());
        }
      }
    }
  }
  ngOnDestroy(): void {
  }
}
